export default __webpack_public_path__ + "static/media/tehdas_paanakyma_360.1c93b718.jpg";